export default __webpack_public_path__ + "static/media/call.00e5b9fb.svg";